import BaseFactory from 'services/sports/default/base-factory';
import LP from 'services/sports/mma/lp/lp-showdown';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new LP(params);
    }
}

export {Factory};
